"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const axios_1 = __importDefault(require("axios"));
const zip_1 = __importDefault(require("../../../../../../../resources/common/assets/js/utils/zip"));
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let ModalsSelectsModuleResults = class ModalsSelectsModuleResults extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // MixPanel init
        this.mixpanelHandler = new MixpanelHandler_1.default();
        this.closeModal = false;
        this.loading = false;
        this.loadingAll = false;
        this.loadingUnique = '';
        this.loadingQr = false;
        this.qrError = false;
        this.qrErrorMessage = '';
        this.loadingUniqueOpen = '';
        this.loadingUniqueAnonymised = '';
        this.loadingAllSecundary = false;
        this.loadingSecundary = false;
    }
    imgSrc(code) {
        if (code)
            return `data:image/gif;base64,${code}`;
        return null;
    }
    actionModal() {
        this.$emit('actionModal', true);
        if (this.typeModal === 'qr') {
            this.dwImg();
        }
        else if (this.typeModal === 'qrTrials') {
            this.dwQrImg();
        }
    }
    async dwQrImg() {
        this.loadingQr = true;
        const fileLink = document.createElement('a');
        fileLink.href = this.imgSrc(this.codeQrTrials);
        fileLink.setAttribute('download', 'QR.png');
        document.body.appendChild(fileLink);
        this.qrError = false;
        fileLink.click();
        setTimeout(() => {
            this.loadingQr = false;
        }, 1000);
    }
    closeModalAction() {
        this.closeModal = true;
        this.$emit('closeModal', true);
    }
    downloadQrMixPanel() {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('downloadQr', {
            origin: originModule,
        });
    }
    async dwImg() {
        this.downloadQrMixPanel();
        this.loadingQr = true;
        await (0, axios_1.default)({
            url: '/rate/' + this.certificateId + '/qr',
            method: 'GET',
            responseType: 'blob',
        })
            .then((response) => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'QR_Becrop_Rate.png');
            document.body.appendChild(fileLink);
            this.qrError = false;
            fileLink.click();
        })
            .catch((error) => {
            this.qrError = true;
            console.log(error);
            this.qrErrorMessage = error;
        });
        this.loadingQr = false;
    }
    downloadUniqueReportMixPanel() {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('downloadUniqueReport', {
            origin: originModule,
        });
    }
    async downloadUniqueReport(reportCode) {
        this.downloadUniqueReportMixPanel();
        this.loadingUnique = reportCode;
        const url = '/data/results/report/pdf/' + reportCode;
        await fetch(url)
            .then((res) => {
            return res.blob();
        })
            .then((data) => {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'myFile.pdf');
            document.body.appendChild(link);
            link.click();
            this.qrError = false;
        })
            .catch((error) => {
            this.qrError = true;
            console.log(error);
            this.qrErrorMessage = error;
            this.loadingUnique = '';
        });
        this.loadingUnique = '';
    }
    async openUniqueReport(reportCode) {
        this.loadingUniqueOpen = reportCode;
        const url = '/data/results/report/pdf/' + reportCode;
        await fetch(url)
            .then((res) => {
            return res.blob();
        })
            .then((data) => {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'myFile.pdf');
            document.body.appendChild(link);
            window.open('/data/results/report/pdf/' + reportCode);
            this.qrError = false;
        })
            .catch((error) => {
            this.qrError = true;
            console.log(error);
            this.qrErrorMessage = error;
            this.loadingUnique = '';
        });
        this.loadingUniqueOpen = '';
    }
    async downloadUniqueReportAnonymised(reportCode) {
        this.loadingUniqueAnonymised = reportCode;
        const url = '/data/results/report/pdf/' + reportCode + '?anonymize=true';
        await fetch(url)
            .then((res) => {
            return res.blob();
        })
            .then((data) => {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'mdfsds.pdf');
            document.body.appendChild(link);
            link.click();
            this.qrError = false;
        })
            .catch((error) => {
            this.qrError = true;
            console.log(error);
            this.qrErrorMessage = error;
            this.loadingUniqueAnonymised = '';
        });
        this.loadingUniqueAnonymised = '';
    }
    downloadAllReportsMixPanel() {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('downloadAllReports', {
            origin: originModule,
        });
    }
    async downloadAllReports(reports) {
        this.downloadAllReportsMixPanel();
        if (this.valuesOptionsSecondary !== reports) {
            this.loadingAll = true;
        }
        else {
            this.loadingAllSecundary = true;
        }
        const zipname = this.valuesOptionsSecondary === reports
            ? this.nameZipSecondary + '.zip'
            : this.nameZip + '.zip';
        const zip = new zip_1.default();
        for (const sample of reports) {
            const url = '/report/pdf/' + sample.code;
            await zip
                .addURL(url)
                .then(() => { })
                .catch((error) => {
                this.qrError = true;
                console.log(error);
                this.qrErrorMessage = error;
                this.loadingAll = false;
                this.loadingAllSecundary = false;
            });
        }
        zip.download(zipname);
        this.loading = false;
        this.loadingAll = false;
        this.loadingAllSecundary = false;
    }
    downloadAllReportsAnonymizeMixPanel() {
        const originModule = localStorage.getItem('currentModule');
        this.mixpanelHandler.trackEvent('downloadAllReportsAnonymize', {
            origin: originModule,
        });
    }
    async downloadAllReportsAnonymize(reports) {
        this.downloadAllReportsAnonymizeMixPanel();
        if (this.valuesOptionsSecondary !== reports) {
            this.loading = true;
        }
        else {
            this.loadingSecundary = true;
        }
        const zipname = this.valuesOptionsSecondary === reports
            ? this.nameZipSecondary + '__anonymize.zip'
            : this.nameZip + '__anonymize.zip';
        const zip = new zip_1.default();
        for (const sample of reports) {
            const url = '/data/results/report/pdf/' + sample.code + '?anonymize=true';
            await zip
                .addURL(url)
                .then(() => { })
                .catch((error) => {
                this.qrError = true;
                this.qrErrorMessage = error;
                this.loading = false;
                this.loadingSecundary = false;
            });
        }
        zip.download(zipname);
        this.loading = false;
        this.loadingSecundary = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalsSelectsModuleResults.prototype, "typeModal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalsSelectsModuleResults.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalsSelectsModuleResults.prototype, "subtitle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalsSelectsModuleResults.prototype, "btnText", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalsSelectsModuleResults.prototype, "errorCertificate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ModalsSelectsModuleResults.prototype, "areaSelectId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], ModalsSelectsModuleResults.prototype, "certificateId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ModalsSelectsModuleResults.prototype, "valuesOptions", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: null })
], ModalsSelectsModuleResults.prototype, "valuesOptionsSecondary", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalsSelectsModuleResults.prototype, "nameZip", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalsSelectsModuleResults.prototype, "nameZipSecondary", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ModalsSelectsModuleResults.prototype, "isDistributor", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ModalsSelectsModuleResults.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], ModalsSelectsModuleResults.prototype, "codeQrTrials", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], ModalsSelectsModuleResults.prototype, "customClass", void 0);
ModalsSelectsModuleResults = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'ModalsSelectsModuleResults',
        components: {
            Modal: bmk_ui_framework_1.Modal,
            MapPin: lucide_vue_next_1.MapPin,
            Button: bmk_ui_framework_1.Button,
            Select: bmk_ui_framework_1.Select,
            RateLogo: bmk_ui_framework_1.RateLogo,
            FolderIcon: bmk_ui_framework_1.FolderIcon,
            Download: lucide_vue_next_1.Download,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Infinity: lucide_vue_next_1.Infinity,
            QRCode: bmk_ui_framework_1.QRCode,
            Loader: bmk_ui_framework_1.Loader,
            ViewZero: bmk_ui_framework_1.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            Glasses: lucide_vue_next_1.Glasses,
            Separator: bmk_ui_framework_1.Separator,
            Save: lucide_vue_next_1.Save,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
        },
    })
], ModalsSelectsModuleResults);
exports.default = ModalsSelectsModuleResults;
